import { Grid } from '@material-ui/core';
import React from 'react';
import { Colors, PrimaryButton, Text, TruncateText } from 'library';
import { UserPostModel, FamilyRoleInfo } from '../../../NewsfeedModels';
import BulletSection from '../../components/BulletSection';
import UserInfoModal from '../../components/UserInfoModal';

interface IProps {
    user: UserPostModel;
    onMessageClick: () => void;
}

export default function UserProfile({ user, onMessageClick }: IProps) {
    return (
        <Grid container>
            <Grid item xs={12} sm={5} style={{ padding: 30, backgroundColor: Colors.lightTurq }}>
                <UserInfoModal user={user} />
            </Grid>
            <Grid item xs={12} sm={7} style={{ padding: 30 }}>
                <Grid container item direction="column" spacing={2}>
                    <BulletSection user={user} />

                    {(user.role_info as FamilyRoleInfo).bio !== undefined ? (
                        <Grid item>
                            {(user.role_info as FamilyRoleInfo).bio.length > 200 ? (
                                <TruncateText text={(user.role_info as FamilyRoleInfo).bio} length={200} />
                            ) : (
                                <Text variant="body1">{(user.role_info as FamilyRoleInfo).bio}</Text>
                            )}
                        </Grid>
                    ) : (
                        <></>
                    )}
                    <Grid item>
                        <PrimaryButton onClick={onMessageClick}>Message</PrimaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
